import React, { forwardRef } from 'react';
import { Icon } from '../icon';
import { getColor } from '../../../src/styled/utils';
import { useTheme } from 'styled-components';
import { useTextOverflow } from './hooks/use-overflow-detect';
import { StyledFormHelperText, StyledTooltip } from './styled';
const iconGetter = (msgType) => {
    switch (msgType) {
        case 'error': {
            return { name: 'close_circle', color: 'danger' };
        }
        case 'success': {
            return { name: 'check_circle', color: 'success' };
        }
        case 'warning': {
            return { name: 'warning_amber', color: 'warning' };
        }
        case 'info':
        default: {
            return { name: 'info', color: 'onSurface' };
        }
    }
};
const ICON_STYLE = { fontSize: 14 };
const HelperIcon = ({ msgType, icon }) => {
    const theme = useTheme();
    if (icon === null)
        return null;
    const currentIcon = iconGetter(msgType);
    return icon ? (icon) : (React.createElement(Icon
    // hack for cut padding inside svg
    // works only for 'close_circle' | 'check_circle'
    , { 
        // hack for cut padding inside svg
        // works only for 'close_circle' | 'check_circle'
        viewBox: "3 3 14 14", style: ICON_STYLE, 
        // end hack
        key: currentIcon.name, name: currentIcon.name, color: getColor(currentIcon.color)({ theme }) }));
};
export const FormHelperText = forwardRef(function FormHelperText({ children, icon, msgType, fixedPadding = false, ...rest }, ref) {
    const [textRef, isOverflowing] = useTextOverflow(children);
    const displayChildren = children !== ' ' && children;
    const responsiveOverflow = fixedPadding && isOverflowing;
    return responsiveOverflow ? (React.createElement(StyledTooltip, { withArrow: false, content: children, position: "bottom" },
        React.createElement(StyledFormHelperText, { "data-testid": "form-helper-text", ref: ref, "$msgType": msgType, fixedPadding: fixedPadding, ...rest },
            React.createElement(HelperIcon, { icon: icon, msgType: msgType }),
            React.createElement("span", { ref: textRef }, children)))) : (React.createElement(StyledFormHelperText, { "data-testid": "form-helper-text", ref: ref, "$msgType": msgType, fixedPadding: fixedPadding, ...rest }, displayChildren && (React.createElement(React.Fragment, null,
        React.createElement(HelperIcon, { icon: icon, msgType: msgType }),
        React.createElement("span", { ref: textRef }, children)))));
});
